import { UserInfoModel } from 'mvppoker-portal-common/api'
import React, { useRef, useState } from 'react'
import { MdEdit as EditIcon } from 'react-icons/md'
import { MVPButton } from '../../Buttons/MVPButton'
import ProfileImage from '../../ProfileImage'
import './ProfileModal.scss'

export type ProfileModalViewFormData =
{
	image: FileList
}
export interface ProfileModalViewProps
{
	userInfo: UserInfoModel
	clickSubmit: (image: File) => void
	clickContactSupport: () => void
	clickCancel: () => void
}

export const ProfileModalView : React.FC<ProfileModalViewProps> = ({ userInfo, clickSubmit, clickContactSupport, clickCancel }) =>
{
	const [imageUrl, setImageUrl] = useState<string>(userInfo.avatar)

	const inputRef = useRef<HTMLInputElement | null>(null)
	const clickProfileImage = () => {
		inputRef.current?.click()
	}

	return (
		<>
			<span id='title' className='modal-title-l'>Your Profile</span>
			<p id='profile-name'>{userInfo.name}</p>
			<button id='profile-picture' type='button' onClick={clickProfileImage}>
				<ProfileImage alt='profile' src={imageUrl} />
				<span>
					<EditIcon />
					Edit
				</span>
			</button>
			<input
				type='file'
				ref={(e) => {
					inputRef.current = e
				}}
				onChange={(e) => {
					if (e.target.files && e.target.files.length > 0) {
						const file = e.target.files[0]
						setImageUrl(URL.createObjectURL(file))
						clickSubmit(file)
					}
				}}
				accept='image/jpeg, image/png'
			/>
			<p id='name-change-info'>To change your name please contact support:</p>
			<div className='button-group'>
				<MVPButton type='button' onClick={clickContactSupport}>
					Contact Support
				</MVPButton>
				<MVPButton type='button' className='clear' onClick={clickCancel}>
					Cancel
				</MVPButton>
			</div>
		</>
	)
}